<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">
    <span *ngIf="!editNote">Add </span>Call In/Out
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="phoneCallDetails" autocomplete="off">

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Call Direction</label>
      <div class="col-sm-9">
        <select class="form-select" formControlName="incoming">
          <option [ngValue]="true">Incoming</option>
          <option [ngValue]="false">Outgoing</option>
        </select>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Caller Type</label>
      <div class="col-sm-9">
        <select class="form-select" formControlName="callerType">
          <option [ngValue]="1">Lender Solicitor</option>
          <option [ngValue]="2">Broker</option>
          <option [ngValue]="3">Estate Agent</option>
          <option [ngValue]="4">Client</option>
          <option [ngValue]="5">Current Lender</option>
          <option [ngValue]="6">Landlord</option>
          <option [ngValue]="7">Land Registry</option>
          <option [ngValue]="0">Other</option>
        </select>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Notes</label>
      <div class="col-sm-9">
        <textarea class="form-control" 
                  formControlName="notes" 
                  rows="6"></textarea>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer" *ngIf="!editNote">
  <button *ngIf="!addingPhoneCall" 
          type="button" 
          class="btn btn-success" 
          (click)="addPhoneCall()" 
          [disabled]="addingPhoneCall || phoneCallDetails.invalid">
    Add
  </button>

  <button *ngIf="addingPhoneCall" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Adding...
  </button>
</div>

<div class="modal-footer" *ngIf="editNote">
  <button *ngIf="!editingPhoneCall" 
          type="button" 
          class="btn btn-success" 
          (click)="updatePhoneCall()" 
          [disabled]="editingPhoneCall">
    Update
  </button>

  <button *ngIf="editingPhoneCall" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Updating...
  </button>
</div>